import * as reactAriaFocus from '@react-aria/focus';
import * as reactAriaOverlays from '@react-aria/overlays';

const focusContexts = (reactAriaFocus as any)?.InternalContexts;
const overlaysContexts = (reactAriaOverlays as any)?.InternalContexts;

export { focusContexts, overlaysContexts };
